import React, { useEffect, Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import agm from '../../services/agm';

import {
  Box,
  Link,
  Card,
  InputLabel,
  Select,
  MenuItem,
  CardContent,
  makeStyles,
  Grid,
  colors,
  Avatar,
  Icon,
  Typography,
  Button,
  TextField,
  InputAdornment,
  SvgIcon,
  TablePagination,
  Paper,
  FormControl,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';

import { Search as SearchIcon } from 'react-feather';
import { TiShoppingCart } from 'react-icons/ti';
import { MdOutlineLaunch } from 'react-icons/md';
import { BiGitRepoForked } from 'react-icons/bi';

import Pager from 'src/utils/Pager';

const useStyles = makeStyles((theme) => ({
  root: {

  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200],
    width: 58,
    height: 58
  },
  iconoperation: {
    width: 45,
    height: 45
  },
  baroperation: {
    width: '100%',
    minHeight: 65
  }
}));

const ColorCheckbox = withStyles({
  root: {
    marginLeft: 0,
    color: colors.cyan[400],
    '&$checked': {
      color: colors.cyan[500],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const defaultDependencies = {
  loaded: false,
  stocks: [],
  categories: []
}

const Toolbar = ({ icon, item, resultset, resultModes, vision, visions, selectedMode, openCreation, openRequest, changeFilter }) => {

  const classes = useStyles();

  const [startDateTime, setStartDateTime] = useState(defaultStartDateTime);
  const [endDateTime, setEndDateTime] = useState(defaultEndDateTime);
  const [keyword, setKeyword] = useState('');
  const [query, setQuery] = useState(vision);
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(10);
  const [stock, setStock] = useState(1);
  const [category, setCategory] = useState(-1);
  const [qtdLoaded, setQtdLoaded] = useState(true);

  const [dependencies, setDependencies] = useState(defaultDependencies);

  const changeCategory = (event) => {
    setCategory(event.target.value);
    setPage(0);
    changeFilter(
      query,
      keyword,
      page,
      rows,
      startDateTime,
      endDateTime,
      stock,
      qtdLoaded,
      event.target.value);
  }

  const changeStock = (event) => {
    setStock(event.target.value);
    setPage(0);
    changeFilter(
      query,
      keyword,
      page,
      rows,
      startDateTime,
      endDateTime,
      event.target.value,
      qtdLoaded,
      category);
  }

  const changeQtdLoaded = (event) => {
    setPage(0);
    setQtdLoaded(event.target.checked)
    changeFilter(
      query,
      keyword,
      page,
      rows,
      startDateTime,
      endDateTime,
      stock,
      event.target.checked,
      category);
  }


  const changeStartDatetime = (value) => {
    setStartDateTime(value);
    setPage(0);
    changeFilter(
      query,
      keyword,
      page,
      rows,
      value,
      endDateTime,
      stock,
      qtdLoaded,
      category);
  }

  const changeEndDatetime = (value) => {
    setEndDateTime(value);
    setPage(0);
    changeFilter(
      query,
      keyword,
      page,
      rows,
      startDateTime,
      value,
      stock,
      qtdLoaded,
      category);
  }

  const changeQuery = (event) => {
    setQuery(event.target.value);
    setPage(0);
    changeFilter(
      event.target.value,
      keyword,
      page,
      rows,
      startDateTime,
      endDateTime,
      stock,
      qtdLoaded,
      category);
  }

  const changeKeyword = (event) => {
    setKeyword(event.target.value);
    setPage(0);
    changeFilter(
      query,
      event.target.value,
      page,
      rows,
      startDateTime,
      endDateTime,
      stock,
      qtdLoaded,
      category);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    changeFilter(
      query,
      keyword,
      newPage,
      rows,
      startDateTime,
      endDateTime,
      stock,
      qtdLoaded,
      category);
  };

  const handleChangeRowsPerPage = (event) => {
    var rowsPerPage = parseInt(event.target.value, 10);
    setPage(0);
    setRows(rowsPerPage);
    changeFilter(
      query,
      keyword,
      page,
      rowsPerPage,
      startDateTime,
      endDateTime,
      stock,
      qtdLoaded,
      category);
  };


  const loadDependencies = ((value) => {
    agm.get('/produtos/filtro/-1', {}, {}).then((response) => {
      if (!response.data.error) {
        setDependencies({ stocks: response.data.estoques, categories: response.data.categorias });
      } else {
        return defaultDependencies;
      }
    }).catch((error) => {
      console.error(error);
    })
  });

  useEffect(() => {
    if (!dependencies.loaded) {
      loadDependencies({});
    }
    return
  }, []);

  return (
    <Fragment>
      <Box className={classes.baroperation}>

        <Grid container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item
            md="auto"
            xs="auto">
            <Avatar variant="rounded"
              className={classes.avatar}
            >
              {<Icon className={classes.iconoperation} component={icon} style={{ color: colors.cyan[400] }} ></Icon>}
            </Avatar>

          </Grid>

          <Grid item
            md="auto"
            xs="auto">
            <Typography
              color="primary"
              variant="h5"
            >
              Você esta na área de <b>{<Link color="inherit" href="/mgt/main">MANUTENÇÃO</Link>}</b>. A operação padrão é <b> {localStorage.getItem('company')}</b>
            </Typography>

            <Typography
              color="secondary"
              variant="h4"
            >
              <b>Estoque</b>
            </Typography>

          </Grid>
        </Grid>
      </Box>

      <Box>
        <Card>
          <CardContent>
            <Grid container
              fullWidth
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-end"
            >
              <Grid item
                md={12}
                xs={12}>

                <Box mb={2}>
                  <Card>
                    <CardContent>
                      <Grid container
                        fullWidth
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        alignContent="flex-start"
                      >
                        <Grid item
                          xs={12}
                        >
                          <Grid container justifyContent="flex-start" spacing={1}>

                            <Grid item
                              md={3}
                              xs={12}
                            >
                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="query">Pesquisa</InputLabel>
                                <Select notched
                                  required={true}
                                  fullWidth={true}
                                  label="Pesquisa"
                                  variant="outlined"
                                  id="query"
                                  name="query"
                                  value={query}
                                  onChange={changeQuery}
                                  inputProps={{
                                    name: 'query',
                                    id: 'query',
                                  }}
                                >

                                  {visions.map((view) => (
                                    <MenuItem key={view.id} value={view}>{view.name}</MenuItem>
                                  ))}

                                </Select>
                              </FormControl>
                            </Grid>

                            <Grid item
                              md={2}
                              xs={12}
                            >
                              <TextField
                                fullWidth
                                disabled={!query.refine}
                                onChange={changeKeyword}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <SvgIcon
                                        fontSize="small"
                                        color="action"
                                      >
                                        <SearchIcon />
                                      </SvgIcon>
                                    </InputAdornment>
                                  )
                                }}
                                placeholder={"Refinar pesquisa por, " + query.label}
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>

                            <Grid
                              item
                              md={2}
                              xs={12}>

                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="stock">Categoria</InputLabel>
                                <Select notched
                                  required={true}
                                  fullWidth={true}
                                  label="Categoria"
                                  variant="outlined"
                                  id="category"
                                  name="category"
                                  value={category}
                                  onChange={changeCategory}
                                  inputProps={{
                                    name: 'category',
                                    id: 'category',
                                  }}
                                >
                                  <MenuItem key={-1} value={-1}>Todos</MenuItem>
                                  {dependencies.categories.map((catg) => (
                                    <MenuItem key={catg.id} value={catg.id}>{catg.nome}</MenuItem>
                                  ))}

                                </Select>
                              </FormControl>

                            </Grid>

                            <Grid
                              item
                              md={3}
                              xs={12}>

                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="stock">Estoque</InputLabel>
                                <Select notched
                                  required={true}
                                  fullWidth={true}
                                  label="Estoque"
                                  variant="outlined"
                                  id="stock"
                                  name="stock"
                                  value={stock}
                                  onChange={changeStock}
                                  inputProps={{
                                    name: 'stock',
                                    id: 'stock',
                                  }}
                                >
                                  {dependencies.stocks.map((stock) => (
                                    <MenuItem key={stock.id} value={stock.id}>{stock.nome}</MenuItem>
                                  ))}

                                </Select>
                              </FormControl>

                            </Grid>

                            <Grid
                              item
                              md={2}
                              xs={12}>
                              <FormControlLabel
                                control={<ColorCheckbox
                                  checked={qtdLoaded}
                                  onChange={changeQtdLoaded} name="qtdloads" />}
                                label="Estoque Maior que Zero"
                              />
                            </Grid>

                          </Grid>

                        </Grid>

                      </Grid>

                    </CardContent>

                  </Card>
                </Box>

              </Grid>

              <Grid item
                md={8}
                xs={12}
              >
                <Grid container
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                >

                  <Grid item
                    md={10}
                    xs={12}
                  >

                    <TablePagination
                      style={{ minWidth: 295 }}
                      variant="caption"
                      component={Paper}
                      className={classes.pager}
                      page={page}
                      rowsPerPage={rows}
                      count={resultset.count}
                      labelRowsPerPage={(screen.width <= 480) ? "" : "Linhas por página"}
                      labelDisplayedRows={(screen.width <= 480) ? (({ from, to, count }) => `${from}-${to} de ${count}`) : (({ from, to, count }) => `Encontrados: ${count}, Apresentando de: ${from} a ${to}`)}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                      ActionsComponent={Pager}
                    />

                  </Grid>

                </Grid>

              </Grid>

              <Grid item
                md={4}
                xs={12}
              >
                <Grid container
                  direction="row-reverse"
                  justifyContent="baseline"
                  alignItems="flex-start"
                >

                  <Grid item
                    md="auto"
                    xs="auto"
                  >
                    {(resultModes[selectedMode].create != LEVEL_ACCESS_HIDE) ? (
                      <Box mt={2} >
                        <Button
                          color="secondary"
                          disabled={resultModes[selectedMode].create == LEVEL_ACCESS_DISABLED}
                          size="small"
                          variant="contained"
                          startIcon={<TiShoppingCart />}
                          onClick={() => { openCreation(item) }}>
                          Lançar Compras
                        </Button>
                      </Box>
                    ) : ('')}

                  </Grid>

                  <Grid item
                    md="auto"
                    xs="auto"
                  >
                    <Box mt={2} >
                      <Button
                        color="secondary"
                        disabled={resultModes[selectedMode].create == LEVEL_ACCESS_DISABLED}
                        size="small"
                        variant="contained"
                        startIcon={<BiGitRepoForked />}
                        onClick={() => { openRequest(item) }}>
                        Lançar Retirada
                      </Button>&nbsp;
                    </Box>

                  </Grid>

                  <Grid item
                    md="auto"
                    xs="auto"
                  >
                    <Box mt={2} >
                      <Button
                        color="secondary"
                        disabled={resultModes[selectedMode].create == LEVEL_ACCESS_DISABLED}
                        size="small"
                        variant="contained"
                        startIcon={<MdOutlineLaunch />}
                        href="/mgt/inventories">
                        Ver Lançamentos
                      </Button>&nbsp;
                    </Box>

                  </Grid>
                </Grid>

              </Grid>

            </Grid>

          </CardContent>

        </Card>

      </Box>

    </Fragment>

  );
};


Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
